import React, { useRef } from 'react';
import { ChoosePaymentMethodProps } from '..';
import { Button, Checkbox, FormControlLabel } from '@mui/material';
import styles from './ChoosePaymentMethod.desktop.module.css';
import { numberWithCommas } from '../../../../common/utils/argMinMax';
import { PlanIcon } from '../../../../component/parentPortal/planCard/planCard';
import { AddressForm } from '../AddressForm';
import { ChoosePaymentMethodElement } from '../ChoosePaymentMethodElement';
import { ReactComponent as BnplIcon } from '../assets/bnpl.svg';
import { ReactComponent as PayTodayIcon } from '../assets/paytoday.svg';

export const DesktopView = (props: ChoosePaymentMethodProps) => {
  const choosePaymentMethodElement = ChoosePaymentMethodElement(
    props.selectedPlan,
  );
  const chosenPlan = (
    <div className={styles.chosenPlanWrapper}>
      <PlanIcon icon={choosePaymentMethodElement.planProps.title.icon} />
      <span className={styles.chosenPlan}>
        Chosen Plan: <b>{choosePaymentMethodElement.planProps.title.title}</b>
      </span>
    </div>
  );

  const paymentOption = (
    <div className={styles.chosenPlanWrapper}>
      {choosePaymentMethodElement.selectedPaymentMethod === 'fullPay' ? (
        <PayTodayIcon />
      ) : choosePaymentMethodElement.selectedPaymentMethod === 'bnpl' ? (
        <BnplIcon />
      ) : (
        <></>
      )}
      <span className={styles.chosenPlan}>
        Payment Option:{' '}
        <b>
          {choosePaymentMethodElement.selectedPaymentMethod === 'fullPay' ? (
            'Pay Today'
          ) : choosePaymentMethodElement.selectedPaymentMethod === 'bnpl' ? (
            'Buy Now, Pay Later'
          ) : (
            <></>
          )}
        </b>
      </span>
    </div>
  );
  return !choosePaymentMethodElement.showAddressForm ? (
    <div className={styles.choosePaymentMainDiv}>
      <div className={styles.titleWrapper}>
        <span className={styles.title}>Payment Options</span>
        <span className={styles.subtitle}>
          You can pay for your program in full today or slice your program cost
          over time.
        </span>
        {chosenPlan}
      </div>
      <div className={styles.cardsWrapper}>
        <div
          className={`${styles.card} ${
            choosePaymentMethodElement.selectedPaymentMethod === 'fullPay' &&
            styles.selected
          }`}
          onClick={choosePaymentMethodElement.fullPayButtonClickHandler}
        >
          <PayTodayIcon />
          <span className={styles.title}>Pay Today</span>
          <span className={styles.subTitle}>
            Pay full amount at checkout to enjoy exclusive discount offer.
          </span>
          <span className={styles.price}>
            HKD $
            {numberWithCommas(
              choosePaymentMethodElement.planPrices.fullPayPrice ?? 0,
            )}
          </span>
        </div>
        <div className={styles.spacer} />
        <div
          className={`${styles.card} ${
            choosePaymentMethodElement.selectedPaymentMethod === 'bnpl' &&
            styles.selected
          }`}
          onClick={choosePaymentMethodElement.bnplButtonClickHandler}
        >
          <BnplIcon />
          <span className={styles.title}>Buy Now, Pay Later</span>
          <span className={styles.subTitle}>
            Enjoy your purchase now and pay later with flexible payment options.
          </span>
          <span className={styles.price}>
            HKD $
            {numberWithCommas(
              choosePaymentMethodElement.planPrices.bnplPrice ?? 0,
            )}
          </span>
        </div>
      </div>

      <FormControlLabel
        control={
          <Checkbox
            onChange={choosePaymentMethodElement.handelTncCheckBoxChange}
          />
        }
        label={
          <span className={styles.tnc}>
            {`By creating account, I agree to Big Bang Lab’s `}
            <a
              onClick={(e) => {
                e.preventDefault();
                choosePaymentMethodElement.openTnc();
              }}
            >
              Terms & Conditions
            </a>
          </span>
        }
      />

      <div className={styles.buttonContainer}>
        <Button
          variant="contained"
          sx={{ width: '100%' }}
          onClick={choosePaymentMethodElement.continueButtonClickHandler}
          disabled={choosePaymentMethodElement.continueDisabled()}
        >
          Continue
        </Button>
        <Button variant="text" sx={{ width: '100%' }} onClick={props.back}>
          Back
        </Button>
      </div>

      {choosePaymentMethodElement.tncDialog}
    </div>
  ) : (
    <AddressForm
      chosenPlan={chosenPlan}
      paymentOption={paymentOption}
      choosePaymentMethodElement={choosePaymentMethodElement}
    />
  );
};
